<template>
  <div>
    <el-dialog class="privacy-dialog" :visible.sync="visible" width="825px" :before-close="handleClose" append-to-body>
      <div class="privacy-content">
        <div class="privacy-title">隐私声明政策</div>
        <div>杭州未斯科技有限公司及其子公司（简称“未斯科技”或“我们”）深知隐私对您的重要性，并会严格遵守国家相关法律法规，尊重您的隐私保护。请在向未斯科技提交个人数据之前，阅读并了解本《隐私政策》（下文简称“本政策”）。</div>
        <div class="level-one-title">一、适用条件</div>
        <div>如果您对我们使用用户的个人信息有任何疑问或顾虑，请通过本政策底部所示联系方式与我们联系。</div>
        <div style="margin-top:14px">e航无忧是未斯科技名下基于互联网和微服务架构的一体化在线研发和运营平台。本政策阐述了未斯科技如何处理您的个人数据，但本政策可能并不涉及所有可能的数据处理情境。有关收集产品或服务特定数据的信息可能由未斯科技在补充政策中，或者在收集数据时提供的通知中发布。</div>
        <div class="level-two-title">我们制定本政策的目的在于帮助您了解以下内容：</div>
        <div class="color66">
          1. 我们如何收集和使用您的个人数据<br>
          2. 我们如何使用 Cookie 和同类技术<br>
          3. 我们如何共享、转让、披露您的个人数据<br>
          4. 未斯科技如何访问或修改您的个人数据<br>
          5. 我们如何保护您的个人数据 6. 本政策如何更新 7. 如何联系我们
        </div>
        <div class="level-one-title">二、政策内容</div>
        <div class="level-two-title">1. 我们如何收集和使用您的个人数据</div>
        <div class="level-two-title">(1)我们收集哪些您的个人信息</div>
        <div>个人数据是指单独使用或结合其他信息使用时能够确定个人身份的信息。此类数据会在您登录e航无忧以及使用在线开发平台功能时由您直接提交给我们或者为了履行合同而统一录入，包括姓名、身份证件号码、账号、邮箱账号、电话号码、计算机名称、Mac地址、计算机IP等。前述个人信息为您使用我们提供的【中外运平台订舱、VGM/舱单/AMS发送、海运跟踪、开票】等业务功能及其研发改进所必须。</div>
        <div style="margin-top:14px;margin-bottom:14px;font-weight:600;font-family: SourceHanSansCN-Medium, SourceHanSansCN;">此外，在您使用下列业务功能或服务时，我们的网站/平台/客户端会向您单独申请下列与个人信息相关的系统权限：</div>
        <div class="color66">(a)为保证您正常使用的【VGM/舱单/AMS】数据发送服务，我们需要收集您的个人信息。如不提供则无法使用该功能。</div>
        <div class="level-two-title">(2)我们如何使用您的个人信息</div>
        <div>我们可能将您的个人数据用于以下目的：</div>
        <div>
          (a) 创建账户和登录。<br>
          (b) 开展内部审计、数据分析和研究，改善我们的产品和服务。<br>
          (c) 在您选择向我们发送错误详情的情况下排查错误。<br>
          (d) 同步、共享和存储您上传或下载的数据以及执行上传和下载所需的数据。<br>
          (e) 保护我们产品、服务和客户或用户的安全，执行与改善我们的防损和反欺诈计划。<br>
          (f) 遵从和执行适用的法律要求，相关的行业标准或我们的政策。 当我们处理您的个人数据时我们会遵从适用的法律的要求基于适当的合法性基础予以处理，包括：
        </div>
        <div class="color66">
          • 为履行合同处理您的个人数据；<br>
          • 基于您的同意处理您的个人数据；<br>
          • 为改善我们的产品和服务，执行与改善我们的防损和反欺诈计划等目的处理您的个人数据时我们将基于我们或第三方的合法利益。这些合法利益包括，使我们能够更有效的管理和运营我们的业务并提供我们的产品和服务；保护我们的业务、系统、产品、服务和客户的安全；内部管理，遵从内部的政策和流程；我们在本政策中描述的其他合法利益等；<br>
          • 我们还可能基于遵从和执行法律义务处理您的个人数据。
        </div>
        <div class="level-two-title">(3)从第三方获得您的个人信息</div>
        <div class="color66">为更好地为您提供服务，我们可能会接收关联公司、业务合作伙伴等第三方提供的您的相关个人信息。例如当您通过我们的关联公司、业务合作伙伴的客户端、网站订购我们的产品，您向其提供的预订信息可能会转交给我们，以便我们处理您的订单。我们会依据与第三方的约定、对接收的个人信息来源的合法性进行确认后，依相关法律、法规及第三方约定使用您的信息。</div>
        <div class="level-two-title">(4)非识别性数据</div>
        <div class="color66">我们还可能收集和使用非识别性数据。非识别性数据是指无法用于确定个人身份的数据。例如，我们会收集汇总的统计数据，例如网站访问量。我们收集此数据的目的在于了解用户如何使用自己的网站、产品和服务。借此，我们可以改善自己的服务，更好地满足客户需求。我们可能会自行决定出于其他目的收集、使用、处理、转移或披露非识别性数据。我们会尽力隔离您的个人数据和非识别性数据，并单独使用这两种数据。如果个人数据掺杂了非识别性数据，依旧会被视作个人数据处理。</div>
        <div class="level-two-title">2. 我们如何使用 Cookie 和同类技术</div>
        <div style="margin-bottom:8px">
          <span>为确保网站正常运转，我们有时会在计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 是一种网络服务器存储在计算机或移动设备上的纯文本文件。Cookie 的内容只能由创建它的服务器检索或读取。每个 Cookie 对您的网络浏览器或移动应用程序都是唯一的。Cookie 通常包含标识符、站点名称以及一些号码和字符。借助于 Cookie，网站能够存储用户偏好或购物篮内的商品等数据。<br>我们启用Cookie的目的与大多数网站或互联网服务提供商启用 Cookie 的目的一样，即改善用户体验。借助于 Cookie，网站能够记住用户的单次访问（使用会话 Cookie）或多次访问（使用永久 Cookie）。借助于 Cookie，网站能够保存设置，例如计算机或移动设备的语言、字体大小和其他浏览偏好。这意味着，用户无需在每次访问时重新配置用户偏好设置。如果某个网站不使用 Cookie，那么在用户每一次打开网页时，该网站都会将其视为新访客。例如，如果您登录某个网站后转到另一个网页，该网站就不会识别出您，而您会被再次注销。 我们不会将 Cookie 用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。有关详情，请参见 </span>
          <el-link type="primary" href="https://www.aboutcookies.org/" target="_blank">https://www.aboutcookies.org/。</el-link>
          <span>您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。如需详细了解如何更改浏览器设置，请访问以下链接：</span>
        </div>
        <div>
          <span class="color66 text-right" style="width:127px;display:inline-block">Internet Explorer：</span>
          <el-link type="primary" href="http://support.microsoft.com/kb/260971" target="_blank">http://support.microsoft.com/kb/260971</el-link><br>
          <span class="color66 text-right" style="width:127px;display:inline-block;position:relative;">Google Chrome：</span>
          <el-link type="primary" href="http://chrome.hrbmby.top/browser.html" style="width:270px" target="_blank">http://chrome.hrbmby.top/browser.html</el-link><br>
          <span class="color66 text-right" style="width:127px;display:inline-block">Mozilla Firefox：</span>
          <el-link type="primary" href="http://support.mozilla.org/en-US/kb/Cookies" target="_blank">http://support.mozilla.org/en-US/kb/Cookies</el-link><br>
          <span class="color66 text-right" style="width:127px;display:inline-block">Safari：</span>
          <el-link type="primary" href="http://support.apple.com/kb/PH5042" target="_blank">http://support.apple.com/kb/PH5042</el-link><br>
          <span class="color66 text-right" style="width:127px;display:inline-block">Opera：</span>
          <el-link type="primary" href="http://www.opera.com/browser/tutorials/security/privacy/" target="_blank">http://www.opera.com/browser/tutorials/security/privacy/</el-link>
        </div>
        <div class="color66">您使用我们的网站意味着您同意按照如上所述使用Cookie</div>
        <div class="level-two-title">3. 我们如何共享、转让、披露您的个人数据</div>
        <div class="level-two-title">(1)共享</div>
        <div class="color66">在某些服务由我们的授权合作伙伴提供的情况下，我们会如本政策描述与该合作伙伴共享您的个人数据。此外，我们可能在我们的关联公司间共享个人数据。</div>
        <div class="level-two-title">(2)转让</div>
        <div class="color66">
          我们仅会在存在如下合理需求的情况下披露您的数据，且无须征得您的进一步同意。<br>
          A.关系国家安全、国防安全的情况时；<br>
          B.关系公共安全、公共卫生、重大公共利益的情况时；<br>
          C.关系犯罪侦查、起诉、审判和判决执行的情况时；<br>
          D.出于维护个人信息主体或其他个人的生命、财产安全，但又很难得到本人同意的情况下；<br>
          E.所收集的个人信息是个人信息主体自行向社会公众公开的信息；<br>
          F.从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；<br>
          G.根据您的要求签订合同所必需的；<br>
          H.用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；<br>
          I.为合法的新闻报道所必需的；<br>
          J.学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的。<br>
          K.法律法规规定的其他情形
        </div>
        <div class="level-two-title">4. 如何访问或修改您的个人数据</div>
        <div class="color66">
          <span>您应确保提交的所有个人数据都准确无误。我们会尽力维护个人数据的准确和完整，并及时更新这些数据。</span><br>
          <span>当适用的法律要求的情况下，您可能(1)有权访问我们持有的关于您的特定的个人数据；(2)要求我们更新或更正您的不准确的个人数据；(3)拒绝或限制我们使用您的个人数据；以及(4)要求我们删除您的个人数据。如果您想行使相关的权利，请访问</span>
          <el-link type="primary" href="http://app.eline56.com/#/contactUs" target="_blank">https://app.eline56.com/#/contactUs</el-link>
          <span>在线反馈给我们。为保障安全，您可能需要提供书面请求。如果我们有合理依据认为这些请求存在欺骗性、无法实行或损害他人隐私权，我们则会拒绝处理请求。</span><br>
          <span>当适用的法律要求的情况下，当我们基于您的同意处理您的个人数据时，您还有权随时撤销您的同意。但撤销同意不会影响撤销前我们基于您的同意处理您个人数据的合法性及效力，也不影响我们基于其他适当的正当性基础处理您的个人数据。</span>
        </div>
        <div class="level-two-title">5. 我们如何保护和留存您的个人数据</div>
        <div class="color66">我们重视个人数据的安全。我们采用适当的物理、管理和技术保障措施来保护您的个人数据不被未经授权访问、披露、使用、修改、损坏或丢失。例如，我们会使用加密技术确保数据的机密性；我们会使用保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人数据；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人数据重要性的认识。我们会尽力保护您的个人数据，但是请注意任何安全措施都无法做到无懈可击。<br>我们将会在达成本政策所述目的所需的期限内保留您的个人数据，除非按照法律要求或许可需要延长保留期或受到法律的允许。因为基于不同的场景和产品及服务的不同，数据的存储期可能会有所不同，我们用于确定存留期的标准包括：完成该业务目的需要留存个人数据的时间，包括提供产品和服务，维护相应的交易及业务记录，管控并提升产品与服务性能与质量，保证系统、产品和服务的安全，应对可能的用户查询或投诉，问题定位等；用户是否同意更长的留存期间；法律、合同等是否有保留数据的特殊要求等。只要您的账户是为您提供服务必须，我们都将保留您的注册信息。您也可以选择注销您的账号，在您注销账号后，我们会停止基于该账号提供产品和服务，并在无特殊法律要求的情况下，删除您相应的个人数据。 我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内，不存在境外收集用户信息情况。</div>
        <div class="level-two-title">6. 本政策如何更新</div>
        <div class="color66">
          我们保留不时更新或修改本政策的权利。如果我们的隐私政策变更，我们会将最新版隐私政策发布在这里。如果我们对隐私政策做出了重大变更，我们还可能会通过不同渠道向您发送变更通知，例如，在我们的网站上发布通知。<br>
          本条所指的更新包括但不限于：<br>
          • 外部合法合规环境发生变化时；<br>
          • 服务模式发生重大变化，如：个人数据的收集范围、使用目的等；<br>
          • 个人数据处理方面的权利及其行使方式发生重大变化；<br>
          • 联络方式及投诉渠道发生变化时。
        </div>
        <div class="level-two-title">7. 如何联系我们</div>
        <div class="color66">
          <div>
            <span>如果您有任何隐私投诉或问题要联系未斯科技数据保护官，请访问</span>
            <span class="link" @click="contactUs">https://app.eline56.com/#/contactUs。</span>
          </div>
          <span>当未斯科技按照本隐私政策处理您的个人数据时，响应您的请求、与您联系、向您提供产品或服务或与您达成或即将达成合同的未斯科技实体是相关个人数据的控制者。各未斯科技实体的联系信息可访问查看。</span>
        </div>
        <div class="level-two-title" style="text-align:right">最后更新时间: 2021年 12 月 13 日</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "privacy",
  props: {
    visible:{
      type:Boolean,
      default:false
    },
  },
  data(){
    return{}
  },
  created() {},
  methods: {
    handleClose(){
      this.$parent.privacyDialogVisible = false;
    },
    contactUs(){
      window.open('http://app.eline56.com/#/contactUs', '_blank');
    }
  }
}
</script>

<style scoped lang="less">
.privacy-dialog {
  /deep/.el-dialog__body {
    padding: 30px 0;
  }
  /deep/.el-link.el-link--primary {
    color: #00a0e9 !important;
  }
  .privacy-content {
    padding: 0 96px;
    color: #222222;
    font-size: 14px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    line-height: 22px;
  }
  .privacy-title {
    font-size: 22px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    line-height: 33px;
    text-align: center;
    margin-bottom: 24px;
  }
  .level-one-title {
    font-size: 18px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 600;
    margin-top: 26px;
    margin-bottom: 12px;
  }
  .level-two-title {
    font-size: 16px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 600;
    margin-top: 16px;
    margin-bottom: 16px;
  }
  .color66 {
    color: #666666;
  }
  .text-right {
    text-align: right;
  }
  .link {
    color: #00a0e9 !important;
    cursor: pointer;
  }
  .link:hover {
    border-bottom: 1px solid #00a0e9;
  }
}
</style>